export enum AuthRoleIdEnum {
  ORG_ADMIN = 1,
  ADMIN = 2,
  BASIC_USER = 3
}

export enum AuthRoleNameEnum {
  ORG_ADMIN = 'Org Admin',
  ADMIN = 'Admin',
  BASIC_USER = 'Standard User'
}

export enum EQualityOfSearchFeature {
  GOOD = 'good',
  BAD = 'bad'
}
